import api from "@/api.js";
import categories from "./categories/";
import sources from "./sources/";
import data from "./data/";

export default {
  namespaced: true,
  modules: {
    categories,
    sources,
    data,
  },
  state: {
    list: [],
    outcomesSourcesList: [],
    listLoading: false,
    chosenOutcome: null,
    //this state is set when outcome is selected from the table for the Outcome Dialog
    selectedOutcome: null,
    outcomesCategories: [],

    keyReferenceList: {},
  },
  mutations: {
    setList(state, payload) {
      state.list = payload;

      state.keyReferenceList = {};
      payload.forEach((o) => {
        state.keyReferenceList[o.id] = o;
      });
    },
    setListLoading(state, payload) {
      state.listLoading = payload;
    },
    setChosenOutcome(state, payload) {
      state.chosenOutcome = payload;
    },
    setSelectedOutcome(state, payload) {
      state.selectedOutcome = payload;
    },
    setOutcomesSourcesList(state, payload) {
      state.outcomesSourcesList = payload;
    },
    setOutcomesCategories(state, payload) {
      state.outcomesCategories = payload;
    },
  },
  actions: {
    async loadAll({ commit }) {
      commit("setListLoading", true);
      let list = await api.get("/outcomes");
      commit("setList", list.data);
      commit("setListLoading", false);
    },
    async loadOutcomeByID({ commit }, id) {
      commit("setListLoading", true);
      let list = await api.get("/outcomes/byID", { params: { id: id } });
      commit("setSelectedOutcome", list.data[0]);
      commit("setListLoading", false);
    },
    async loadAllOutcomesSources({ commit }) {
      commit("setListLoading", true);
      let list = await api.get("/outcomesSources");
      commit("setOutcomesSourcesList", list.data);
      commit("setListLoading", false);
    },
    async loadAllOutcomesCategoriesByOutcomesID({ commit }, id) {
      commit("setListLoading", true);
      let list = await api.get("/outcomesCategories/ByOutcomesID", {
        params: { id: id },
      });
      commit("setOutcomesCategories", list.data);
      commit("setListLoading", false);
    },
    async loadAllOutcomesCategories({ commit }) {
      commit("setListLoading", true);
      let list = await api.get("/outcomesCategories");
      commit("setOutcomesCategories", list.data);
      commit("setListLoading", false);
    },
    async newDatatype({ dispatch }, payload) {
      let returnData = {};
      await api
        .post("/outcomes/addDatatype", payload)
        .then((response) => {
          if (response.data.Result == "Success") {
            returnData = {
              Result: "Success",
              Response: response.data,
            };
          } else {
            returnData = {
              Result: "Failed",
              Response: response.data,
            };
          }
        })
        .catch((err) => {
          return (returnData = {
            Result: "Error",
            Response: err,
          });
        });
      dispatch("loadAll");
      return returnData;
    },
    async loadOutcomesSourcesBySourceID({ commit }, sourceID) {
      commit("setListLoading", true);
      let list = await api.get("/outcomesSources/bySourceID", {
        params: { id: sourceID },
      });
      commit("setOutcomesSourcesList", list.data);
      commit("setListLoading", false);
    },
    async newGoal({ dispatch }, payload) {
      let returnData = {};
      await api
        .post("/outcomes/addGoal", payload)
        .then((response) => {
          if (response.data.Result == "Success") {
            returnData = {
              Result: "Success",
              Response: response.data,
            };
          } else {
            returnData = {
              Result: "Failed",
              Response: response.data,
            };
          }
        })
        .catch((err) => {
          return (returnData = {
            Result: "Error",
            Response: err,
          });
        });
      dispatch("loadAll");
      return returnData;
    },
    async newOutcomesSources({ dispatch }, payload) {
      let returnData = {};
      await api
        .post("/outcomesSources", payload)
        .then((response) => {
          if (response.data.Result == "Success") {
            returnData = {
              Result: "Success",
              Response: response.data,
            };
          } else {
            returnData = {
              Result: "Failed",
              Response: response.data,
            };
          }
        })
        .catch((err) => {
          returnData = {
            Result: "Error",
            Response: err,
          };
        });
      dispatch("loadOutcomesSourcesBySourceID", payload.sources_id);
      return returnData;
    },
    async newOutcomesCategory({ dispatch }, payload) {
      let returnData = {};
      await api
        .post("/outcomesCategories", payload)
        .then((response) => {
          if (response.data.Result == "Success") {
            returnData = {
              Result: "Success",
              Response: response.data,
            };
          } else {
            returnData = {
              Result: "Failed",
              Response: response.data,
            };
          }
        })
        .catch((err) => {
          returnData = {
            Result: "Error",
            Response: err,
          };
        });
      dispatch("loadOutcomesSourcesBySourceID", payload.sources_id);
      dispatch("loadAllOutcomesCategories");
      // dispatch("loadAllOutcomesCategoriesByOutcomesID", payload.outcomes_id);
      return returnData;
    },

    async saveOutcomesCategory({ dispatch }, payload) {
      let returnData = {};
      await api
        .put("/outcomesCategories", payload)
        .then((response) => {
          if (response.data.Result == "Success") {
            returnData = {
              Result: "Success",
              Response: response.data,
            };
          } else {
            returnData = {
              Result: "Failed",
              Response: response.data,
            };
          }
        })
        .catch((err) => {
          returnData = {
            Result: "Error",
            Response: {
              Message: "There was an Error, Please try again later",
            },
          };
        });
      dispatch("loadOutcomesSourcesBySourceID", payload.sources_id);
      dispatch("loadAllOutcomesCategoriesByOutcomesID", payload.outcomes_id);
      return returnData;
    },
    async saveOutcomesSources({ dispatch }, payload) {
      let returnData = {};
      await api
        .put("/outcomesSources", payload)
        .then((response) => {
          if (response.data.Result == "Success") {
            returnData = {
              Result: "Success",
              Response: response.data,
            };
          } else {
            returnData = {
              Result: "Failed",
              Response: response.data,
            };
          }
        })
        .catch((err) => {
          returnData = {
            Result: "Error",
            Response: err,
          };
        });
      dispatch("loadOutcomesSourcesBySourceID", payload.sources_id);
      return returnData;
    },
    async new({ dispatch }, payload) {
      let returnData = {};
      await api
        .post("/outcomes", payload)
        .then((response) => {
          if (response.data.Result == "Success") {
            returnData = {
              Result: "Success",
              Response: response.data,
            };
          } else {
            returnData = {
              Result: "Failed",
              Response: response.data,
            };
          }
        })
        .catch((err) => {
          returnData = {
            Result: "Error",
            Response: err,
          };
        });
      dispatch("loadAll");
      return returnData;
    },
    async save({ dispatch }, payload) {
      let returnData = {};
      //Uploading Image
      if (payload.imageUrl) {
        let uploadImageResult = await api.post("outcomes/uploadOutcomeImage", {
          id: payload.id,
          imageData: payload.imageUrl.dataUrl,
        });
        delete payload.imageUrl;
        if (uploadImageResult.data.Result == "Success") {
          payload.imageUrl = uploadImageResult.data.objectUrl;
        }
      }
      await api
        .put(`/outcomes`, payload)
        .then((response) => {
          if (response.data.Result == "Success") {
            returnData = {
              Result: "Success",
              Response: response.data,
            };
          } else {
            returnData = {
              Result: "Failed",
              Response: response.data,
            };
          }
        })
        .catch((err) => {
          returnData = {
            Result: "Error",
            Response: {
              Message: "There was an Error, Please try again later",
            },
          };
        });
      dispatch("loadAll");
      return returnData;
    },
    async select({ commit, dispatch }, payload) {
      commit("setChosenOutcome", payload);
      // if (payload) {
      //   dispatch("questions/loadForOutcome", payload.id, { root: true });
      // } else {
      //   dispatch("questions/clearListForOutcome", null, { root: true });
      // }
    },
    async uploadThumbnail({ commit, dispatch }, payload) {
      let returnData = {};
      await api
        .post(`sustainabilityplans/outcomes/uploadThumbnail`, payload)
        .then((response) => {
          if (response.data.Result == "Success") {
            returnData = {
              Result: "Success",
              Response: response.data,
            };
          } else {
            returnData = {
              Result: "Failed",
              Response: response.data,
            };
          }
        })
        .catch((err) => {
          returnData = {
            Result: "Error",
            Response: {
              Message: "There was an Error, Please try again later",
            },
          };
        });
      dispatch("loadAll");
      return returnData;
    },
  },
  getters: {
    list(state) {
      return state.list;
    },
    listLoading(state) {
      return state.listLoading;
    },
    listDataOutcomes(state) {
      return state.list.filter(o => o.dataAssessmentTool);
    },
    listScaleOutcomes(state) {
      return state.list.filter(o => o.scaleAssessmentTool);
    },
    listIncludeAll(state) {
      let list = JSON.parse(JSON.stringify(state.list));
      list.unshift({ label: "All", id: null });
      return list;
    },
    chosenOutcome(state) {
      return state.chosenOutcome;
    },
    selectedOutcome(state) {
      return state.selectedOutcome;
    },
    outcomesSourcesList(state) {
      return state.outcomesSourcesList;
    },
    outcomesCategories(state) {
      return state.outcomesCategories;
    },
    outcomesByUmbrella(state) {
      let umbrellas = [];
      state.list.forEach((e) => {
        if (umbrellas.length <= 0) {
          let umbrella = {
            umbrella: e.umbrella,
            outcomes: [],
          };
          umbrella.outcomes.push(e);
          umbrellas.push(umbrella);
        } else {
          let index = umbrellas.findIndex((u) => u.umbrella == e.umbrella);
          if (index > -1) {
            umbrellas[index].outcomes.push(e);
          } else {
            let umbrella = {
              umbrella: e.umbrella,
              outcomes: [],
            };
            umbrella.outcomes.push(e);
            umbrellas.push(umbrella);
          }
        }
      });
      return umbrellas;
    },
    keyReferenceList(state) {
      return state.keyReferenceList;
    },
  },
};
